import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import {
  SearchResultBoxComponent,
  SearchResultsBoxComponent,
  SearchSearchAutocompleteComponent,
  SearchTitleComponent,
} from './components';
import { SearchRoutingModule } from './search-routing.module';
import { SearchResults, SearchView } from './views';

const components = [
  SearchSearchAutocompleteComponent,
  SearchTitleComponent,
  SearchResultBoxComponent,
  SearchResultsBoxComponent,
];
const views = [SearchView, SearchResults];
@NgModule({
  declarations: [views, components],
  imports: [SharedModule, CommonModule, SearchRoutingModule],
  providers: [{ provide: APP_BASE_HREF, useValue: '/' }],
  exports: [components, views],
})
export class SearchModule {}
